/* eslint-disable max-len */
const KTGlobalComponentsConfig = {
  collapse: {
    hiddenClass: 'hidden',
  },
  dismiss: {
    hiddenClass: 'hidden',
  },
  tabs: {
    hiddenClass: 'hidden',
  },
  accordion: {
    hiddenClass: 'hidden',
  }
};

export default KTGlobalComponentsConfig;

